import { ibhApiService } from '@hub/bearing-hub/common/api-service';
import type { IbhBearingMaterialsParams } from '@igus/iglidur-bearing-hub-api';
import * as Sentry from '@sentry/nextjs';

export const fetchMaterials = async ({ shape, productionMethods, countryCode }: IbhBearingMaterialsParams) => {
  try {
    const response = await ibhApiService.bearingMaterials({ shape, productionMethods, countryCode });
    return response.data;
  } catch (error) {
    Sentry.captureException(error);
    throw new Error(
      `Could not fetch materials for countryCode: ${countryCode} productionMethods: ${JSON.stringify(
        productionMethods
      )} shape: ${shape}`
    );
  }
};
